import { Vue } from 'vue-property-decorator';

export interface Validable extends Vue {
  validation(): { hasErrors: boolean; messages: string[] };
}

export function isImplementValidable(arg: any): arg is Validable {
  return (
    arg !== null &&
    typeof arg === 'object' &&
    typeof arg.validation === 'function'
  );
}
